var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLongToLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 10.55v18.9c0 .748-.602 1.35-1.35 1.35-.748 0-1.35-.602-1.35-1.35v-18.9c0-.748.602-1.35 1.35-1.35.748 0 1.35.602 1.35 1.35zm-7.594 8.494a1.344 1.344 0 010 1.907l-7.65 7.655A1.35 1.35 0 0120.85 26.7l5.344-5.343L3.35 21.35C2.602 21.35 2 20.748 2 20c0-.748.602-1.35 1.35-1.35h22.843l-5.344-5.344a1.35 1.35 0 011.907-1.907l7.65 7.645z"
  })));
}
export default SvgArrowRightLongToLine;